export default __webpack_public_path__ + "static/media/radiant-bright-blue-pink.bd77a638.jpg";